import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import type * as fhirTypes from "fhir/r4";
interface UpdateDispositionParams {
  dispositionCode: string;
  dispositionDescription: string;
}

interface UpdateDispositionResponse {
  references: fhirTypes.DocumentReference[];
}

export const useUpdateDisposition = ({
  encounterId,
  carePlanId,
  dispositionId,
}: {
  encounterId: string;
  carePlanId: string;
  dispositionId?: string;
}) => {
  const queryClient = useQueryClient();
  const { patientId } = useParams({ from: "/patient/$patientId" });
  return useApiMutation<UpdateDispositionResponse, UpdateDispositionParams>({
    mutationOptions: {
      mutationKey:
        QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.Disposition.UPDATE({
          patientId,
          encounterId,
          carePlanId,
        }),
      mutationFn: (params) => {
        return axiosInstance.patch(
          `/charting/careplan/${carePlanId}/disposition/${dispositionId}`,
          params,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey:
            QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.Disposition.DEFAULT(
              {
                patientId,
                encounterId,
                carePlanId,
              },
            ),
        });
      },
    },
  });
};
